import { render, staticRenderFns } from "./teamInner.vue?vue&type=template&id=20484bf1&scoped=true&"
import script from "./teamInner.vue?vue&type=script&lang=js&"
export * from "./teamInner.vue?vue&type=script&lang=js&"
import style0 from "./teamInner.vue?vue&type=style&index=0&id=20484bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20484bf1",
  null
  
)

export default component.exports